import ContainedIcon from '@/components/ContainedIcon';
import QwenIconBase from '@/components/Icons/QwenIcon';

function QwenIcon() {
  return (
    <ContainedIcon size={24} color="#665BE6" borderRadius={6}>
      <QwenIconBase
        sx={{
          width: 16,
          height: 16,
          color: 'white',
        }}
      />
    </ContainedIcon>
  );
}

export default QwenIcon;
